import { AccordionSummary, styled as s } from '@mui/material';
import styled from 'styled-components';
import { AddBoxRounded } from '@mui/icons-material';

export const CustomAccordion = s((props) => <AccordionSummary expandIcon={<AddBoxRounded sx={{ fontSize: '0.9rem' }} />} {...props} />)(
	({ theme }) => ({
		backgroundColor: 'rgba(0, 0, 0, .03)',
		flexDirection: 'row-reverse',
		'& .MuiAccordionSummary-expandIconWrapper': {
			marginLeft: 4,
		},
		'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
			paddingLeft: 4,
		},
		'& .MuiAccordionSummary-content': {
			marginLeft: theme.spacing(1),
		},
		...theme.applyStyles('dark', {
			backgroundColor: 'rgba(255, 255, 255, .05)',
		}),
	})
);

export const Tree = styled('div').withConfig({
	shouldForwardProp: (prop) => prop,
})`
	&:before {
		content: '';
		display: block;
		width: ${(props) => `${!props.open ? props.size : 0}rem`};
		border-bottom: 2px solid #6b7280;
		position: absolute;
		left: ${(props) => `${props.l - 1 + (props.type === 'project' ? 0 : 0.25)}rem`};
		top: ${(props) => `${props.type === 'project' ? (props.last_child ? (props.last_child_open ? '50%' : '14px') : '50%') : '12px'}`};
		/* transition: top 5s ease-in; */
	}
`;
export const Parent = styled('div').withConfig({
	shouldForwardProp: (prop) => prop,
})`
	&:before {
		content: '';
		display: block;
		width: ${(props) => `${props.open ? props.size : 0}rem`};
		border-bottom: 2px solid #6b7280;
		position: absolute;
		left: ${(props) => `${props.l - 1 + (props.type === 'project' ? 0 : 0.25)}rem`};
		top: ${(props) => `${props.type === 'project' ? (props.last_child ? (props.last_child_open ? 32 : 32) : 32) : 32}px`};
	}
	&:after {
		content: '';
		display: block;
		height: ${(props) => `${props.open ? props.h : 0}`};
		border-left: 2px solid #6b7280;
		position: absolute;
		left: ${(props) => `${props.l + 0.5 + (props.type === 'project' ? 0 : 0.25)}rem`};
		top: 44px;
		z-index: 1;
		/* transition: height 0.15s ease-in; */
		transition: ${(props) =>
			`${
				props.last_child
					? props.last_child_open
						? 'height 0.25s cubic-bezier(0.42, 0, 0.05, 0.86);'
						: 'height 0.23s cubic-bezier(0.56, 0.1, 0.25, 0.9);'
					: 'height 0.25s cubic-bezier(0.65, 0.05, 0.36, 1);'
			}`};
		transition-delay: ${(props) => `${props.last_child ? (props.last_child_open ? 0.015 : 0) : 0}s`};
	}
	/* &.open::after {
		transition: height 0.15s ease-in;
	} */
`;
